import { useSelector } from 'react-redux'
import { IRootState } from '../../../redux/types'

interface UseTinyMCEUploadHandlerProps {
  uploadURL: string
}

export function useTinyMCEUploadHandler({ uploadURL }: UseTinyMCEUploadHandlerProps) {
  const { token } = useSelector((state: IRootState) => state.auth)

  const imageUploadHandler = (blobInfo: any, success: any, failure: any) => {
    const xhr = new XMLHttpRequest()
    xhr.withCredentials = false
    const apiURL = import.meta.env.VITE_API_URL
    const assetsURL = import.meta.env.VITE_AWS_URL

    xhr.open('POST', `${apiURL}${uploadURL}`)
    xhr.setRequestHeader('Authorization', `Bearer ${token}`)

    xhr.onload = () => {
      if (xhr.status < 200 || xhr.status >= 300) {
        failure(`HTTP Error: ${xhr.status}. Response: ${xhr.responseText}`)
        return
      }

      let json
      try {
        json = JSON.parse(xhr.responseText)
      } catch (e) {
        failure(`Invalid JSON: ${xhr.responseText}`)
        return
      }

      const imagePath = json.webp_location || json.path

      if (!imagePath || typeof imagePath !== 'string') {
        failure(`Invalid JSON format: Missing 'webp_location' or 'path'. Response: ${xhr.responseText}`)
        return
      }

      const encodedPath = imagePath.split('/').map(encodeURIComponent).join('/')
      const finalUrl = `${assetsURL}/${encodedPath}`

      success(finalUrl)
    }

    xhr.onerror = () => {
      failure(`Image upload failed due to a XHR Transport error. Code: ${xhr.status}`)
    }

    const formData = new FormData()
    const originalFilename = blobInfo.filename() || 'image.png'
    const fileExtension = originalFilename.split('.').pop()
    const uniqueName = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
    const newFilename = `${uniqueName}.${fileExtension}`

    formData.append('file', blobInfo.blob(), newFilename)

    xhr.send(formData)
  }

  return { imageUploadHandler }
}
